<template>
  <button
    :type="buttonType"
    :disabled="isDisabled"
    :class="`${defaultBgColors} ${classes}  ${textColor} line-clamp-1 transform select-none items-center whitespace-nowrap rounded border border-main-primary px-4 py-3 text-min text-white shadow-sm hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-disabled disabled:text-tertiary disabled:shadow-sm`"
    @click="$emit('click')"
    @submit="$emit('submit')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'PrimaryButton',

  props: {
    buttonType: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultBgColors: {
      type: String,
      default: 'bg-main-primary hover:bg-main-secondary active:bg-main-primary',
    },
    classes: {
      type: String,
      default: '',
    },

    textColor: {
      type: String,
      default: 'text-white',
    },
  },

  emits: ['click', 'submit'],

  data() {
    return {
      isDisabled: this.disabled,
    }
  },

  watch: {
    disabled(newValue) {
      this.isDisabled = newValue
    },
  },
}
</script>
